import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import RetrievalTypePopup from './cpns/RetrievalTypePopup.vue';
import CollectionItemTypePopup from './cpns/CollectionItemTypePopup.vue';
import emitter from '@/eventbus/index';
import { Toast } from 'vant';
import { releaseApply } from '@/service/proRequisition';
import useDefaultWarehouse from './hooks/useDefaultWarehouse';
import useUserInfo from './hooks/useUserInfo';
export default defineComponent({
  name: 'ApplyRequisition',
  components: {
    RetrievalTypePopup: RetrievalTypePopup,
    CollectionItemTypePopup: CollectionItemTypePopup
  },
  setup: function setup() {
    var route = useRoute();
    var params = ref({
      release_type: 2,
      oa_type: 0,
      uid: 0,
      contract_name: '',
      dept_id: 0,
      dept_name: '',
      position_id: 0,
      p_name: '',
      remark: '',
      warehouse_id: 0,
      warehouse_address: '',
      warehouse_no: '',
      warehouse_name: '',
      materials: []
    });
    var info = ref({
      release_type: '直接领用',
      oa_type: ''
    });
    //设置默认仓库
    var _useDefaultWarehouse = useDefaultWarehouse(),
      _useDefaultWarehouse2 = _slicedToArray(_useDefaultWarehouse, 2),
      defaultWarehouse = _useDefaultWarehouse2[0],
      getDefaultWarehouseAsync = _useDefaultWarehouse2[1];
    //获取当前用户名和当前用户的部门信息
    var _useUserInfo = useUserInfo(),
      _useUserInfo2 = _slicedToArray(_useUserInfo, 4),
      userInfo = _useUserInfo2[0],
      getUserInfoAsync = _useUserInfo2[1],
      userDeptInfo = _useUserInfo2[2],
      getDepartmentInfoAsync = _useUserInfo2[3];
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _userDeptInfo$value$p, _userDeptInfo$value$t;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getDefaultWarehouseAsync();
          case 2:
            if (defaultWarehouse.value) {
              params.value.warehouse_id = defaultWarehouse.value.id;
              params.value.warehouse_no = defaultWarehouse.value.warehouse_no;
              params.value.warehouse_address = defaultWarehouse.value.warehouse_address;
              params.value.warehouse_name = defaultWarehouse.value.warehouse_name;
            }
            _context.next = 5;
            return getUserInfoAsync();
          case 5:
            if (!userInfo.value.u_name) {
              _context.next = 9;
              break;
            }
            _context.next = 8;
            return getDepartmentInfoAsync();
          case 8:
            //设置默认领用员工信息
            if (userDeptInfo.value) {
              params.value.uid = userDeptInfo.value.id;
              params.value.contract_name = userDeptInfo.value.username;
              params.value.dept_id = userDeptInfo.value.dept_id;
              params.value.dept_name = userDeptInfo.value.dept_name;
              params.value.position_id = (_userDeptInfo$value$p = userDeptInfo.value.position_id) !== null && _userDeptInfo$value$p !== void 0 ? _userDeptInfo$value$p : 0;
              params.value.p_name = (_userDeptInfo$value$t = userDeptInfo.value.title) !== null && _userDeptInfo$value$t !== void 0 ? _userDeptInfo$value$t : '';
            }
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var retrievalTypePopupRef = ref();
    //打开出库类型弹窗
    var openRetrievalTypePopup = function openRetrievalTypePopup() {
      var _retrievalTypePopupRe;
      (_retrievalTypePopupRe = retrievalTypePopupRef.value) === null || _retrievalTypePopupRe === void 0 || _retrievalTypePopupRe.openPopup();
    };
    var confirmRetrievalTypePopup = function confirmRetrievalTypePopup(payload) {
      params.value.release_type = payload.value;
      info.value.release_type = payload.text;
    };
    var collectionItemTypePopupRef = ref();
    //打开领用物品类型弹窗
    var openCollectionItemTypePopup = function openCollectionItemTypePopup() {
      var _collectionItemTypePo;
      (_collectionItemTypePo = collectionItemTypePopupRef.value) === null || _collectionItemTypePo === void 0 || _collectionItemTypePo.openPopup();
    };
    var confirmCollectionItemTypePopup = function confirmCollectionItemTypePopup(payload) {
      params.value.oa_type = payload.value;
      info.value.oa_type = payload.text;
    };
    var router = useRouter();
    var selectWarehouse = function selectWarehouse() {
      //新需求：不让客户选择仓库，直接显示备品备件仓，所以隐藏下面路由跳转
      // router.push({
      //   name: 'SelectWarehouse'
      // })
    };
    var selectStaff = function selectStaff() {
      router.push({
        name: 'SelectStaff'
      });
    };
    var toAddMaterials = function toAddMaterials() {
      if (!params.value.warehouse_name) {
        Toast('请先选择仓库!');
        return;
      }
      router.push({
        name: 'SelectMaterial',
        params: {
          warehouse_id: params.value.warehouse_id
          // defaultCheckedMaterials: params.value.materials
          //   .map((item) => String(item.stone_id) + item.stone_specifications)
          //   .join(',')
        }
      });
    };
    var deleteMaterial = function deleteMaterial(index) {
      params.value.materials.splice(index, 1);
    };
    var editMaterial = function editMaterial(index, release_nums) {
      params.value.materials[index].release_nums = release_nums;
    };
    onMounted(function () {
      emitter.on('select-warehouse', function (payload) {
        console.log('选择的仓库是', payload);
        params.value.warehouse_id = payload.id;
        params.value.warehouse_name = payload.warehouse_name;
        params.value.warehouse_address = payload.warehouse_address;
        params.value.warehouse_no = payload.warehouse_no;
        //清空之前选中的物料列表
        params.value.materials = [];
      });
      emitter.on('select-materials', function (payload) {
        var _params$value$materia;
        console.log('选择的物料是', payload);
        var preIds = params.value.materials.map(function (item) {
          return String(item.stone_id) + item.stone_specifications;
        });
        var futureIds = payload.map(function (item) {
          return String(item.stone_id) + item.stone_specifications;
        });
        //把重新选中的物料中，已经在以前选中的物料列表中存在的物料过滤掉
        var list = payload.map(function (item) {
          return {
            id: '',
            warehouse_id: item.warehouse_id,
            stone_id: item.stone_id,
            stone_no: item.stone_no,
            unit_price: item.unit_price,
            stone_name: item.stone_name,
            stone_specifications: item.stone_specifications,
            unit: item.unit,
            stone_stock: item.stone_stock,
            release_nums: '1',
            release_unit: item.unit,
            conversion_factor: item.conversion_factor,
            remark: '',
            table_index: -1,
            release_money: 0
          };
        }).filter(function (item) {
          return !preIds.includes(String(item.stone_id) + item.stone_specifications);
        });
        //把之前已经选中的物料列表中不在重新选中的物料列表中的物料过滤掉，
        // params.value.materials = params.value.materials.filter((item) =>
        //   futureIds.includes(String(item.stone_id) + item.stone_specifications)
        // )
        (_params$value$materia = params.value.materials).push.apply(_params$value$materia, _toConsumableArray(list));
      });
      emitter.on('select-staff', function (payload) {
        var _payload$position_id, _payload$title;
        console.log('staff', payload);
        params.value.uid = payload.id;
        params.value.contract_name = payload.username;
        params.value.dept_id = payload.dept_id;
        params.value.dept_name = payload.dept_name;
        params.value.position_id = (_payload$position_id = payload.position_id) !== null && _payload$position_id !== void 0 ? _payload$position_id : 0;
        params.value.p_name = (_payload$title = payload.title) !== null && _payload$title !== void 0 ? _payload$title : '';
        // this.cluesType = payload.labelName
        // this.params.cluesType = payload.policeLabelId
      });
    });
    onUnmounted(function () {
      emitter.off('select-clue-type');
    });
    var btnDisabled = ref(false);
    var validateForm = function validateForm() {
      if (!params.value.warehouse_name) {
        Toast('请选择仓库');
        return false;
      }
      if (!params.value.release_type) {
        Toast('请选择出库类型');
        return false;
      }
      if (!params.value.oa_type) {
        Toast('请选择领用物品类型');
        return false;
      }
      if (!params.value.uid || !params.value.dept_id) {
        Toast('请选择领用员工');
        return false;
      }
      if (!params.value.materials.length) {
        Toast('请选择物料');
        return false;
      }
      //校验物料出库数量和实际库存
      var flag1 = params.value.materials.some(function (item) {
        if (Number(item.release_nums) > Number(item.stone_stock)) {
          Toast("".concat(item.stone_name, "\u5E93\u5B58\u4E0D\u8DB3!"));
          return Number(item.release_nums) > Number(item.stone_stock);
        }
      });
      if (flag1) {
        return false;
      }
      var flag2 = params.value.materials.some(function (item) {
        if (Number(item.release_nums) === 0) {
          Toast("".concat(item.stone_name, "\u51FA\u5E93\u6570\u91CF\u4E0D\u80FD\u4E3A0!"));
          return Number(item.release_nums) === 0;
        }
      });
      if (flag2) {
        return false;
      }
      return true;
    };
    var submit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var validateResult, res, _userDeptInfo$value$p2, _userDeptInfo$value$t2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              validateResult = validateForm();
              if (!validateResult) {
                _context2.next = 15;
                break;
              }
              _context2.prev = 2;
              btnDisabled.value = true;
              _context2.next = 6;
              return releaseApply(params.value);
            case 6:
              res = _context2.sent;
              Toast(res.info);
              if (res.status == '1') {
                params.value = Object.assign({}, params.value, {
                  release_type: 2,
                  oa_type: 0,
                  remark: '',
                  materials: []
                });
                if (defaultWarehouse.value) {
                  params.value.warehouse_id = defaultWarehouse.value.id;
                  params.value.warehouse_no = defaultWarehouse.value.warehouse_no;
                  params.value.warehouse_address = defaultWarehouse.value.warehouse_address;
                  params.value.warehouse_name = defaultWarehouse.value.warehouse_name;
                }
                if (userDeptInfo.value) {
                  params.value.uid = userDeptInfo.value.id;
                  params.value.contract_name = userDeptInfo.value.username;
                  params.value.dept_id = userDeptInfo.value.dept_id;
                  params.value.dept_name = userDeptInfo.value.dept_name;
                  params.value.position_id = (_userDeptInfo$value$p2 = userDeptInfo.value.position_id) !== null && _userDeptInfo$value$p2 !== void 0 ? _userDeptInfo$value$p2 : 0;
                  params.value.p_name = (_userDeptInfo$value$t2 = userDeptInfo.value.title) !== null && _userDeptInfo$value$t2 !== void 0 ? _userDeptInfo$value$t2 : '';
                }
                info.value = {
                  release_type: '直接领用',
                  oa_type: ''
                };
              }
              btnDisabled.value = false;
              _context2.next = 15;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](2);
              btnDisabled.value = false;
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 12]]);
      }));
      return function submit() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      params: params,
      info: info,
      retrievalTypePopupRef: retrievalTypePopupRef,
      openRetrievalTypePopup: openRetrievalTypePopup,
      confirmRetrievalTypePopup: confirmRetrievalTypePopup,
      collectionItemTypePopupRef: collectionItemTypePopupRef,
      openCollectionItemTypePopup: openCollectionItemTypePopup,
      confirmCollectionItemTypePopup: confirmCollectionItemTypePopup,
      selectWarehouse: selectWarehouse,
      selectStaff: selectStaff,
      toAddMaterials: toAddMaterials,
      deleteMaterial: deleteMaterial,
      editMaterial: editMaterial,
      submit: submit,
      btnDisabled: btnDisabled
    };
  }
});